import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const DashboardService = {};

DashboardService.getChartPie = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/chart`,
    method: "get",
  });
};
DashboardService.getChartSummary = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/summary`,
    method: "get",
  });
};
DashboardService.getChartInvoice = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/invoice`,
    method: "get",
  });
};
DashboardService.getListTenantHeader = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/microservice-management/list-tenant-using-app`,
    method: "post",
    data: {
      appCode: env.API_APPCODE,
    },
  });
};

// Lấy đơn vị cha
DashboardService.getListBUTenant = function () {
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[parent_id][not]": "NULL",
      "filter[record_status]": "O",
    },
  });
};

// Lấy Chi nhánh thuộc cha
DashboardService.getListBUStore = function (parent_id) {
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[parent_id]": parent_id,
      "filter[record_status]": "O",
    },
  });
};

DashboardService.getListBUMethodSign = function (
  business_unit_code,
  shop_code
) {
  return fetch({
    url: `${env.API_MSP}/business-units/method`,
    method: "get",
    params: {
      business_unit_code,
      shop_code,
    },
  });
};

DashboardService.getListBUMethodSignInfo = function (business_unit_code) {
  return fetch({
    url: `${env.API_MSP}/sign-methods`,
    method: "get",
    params: {
      page: -1,
      "filter[business_unit_code]": business_unit_code,
    },
  });
};
export default DashboardService;
